export default __webpack_public_path__ + "static/media/eas-applications-navbar.47efe766.svg";